
/**
 * Facebook - This represents the facebook icon
 *
 * @note You may need to swap up the colors if you want to match the facebook
 * logo, this component alone is a blue F. To fix this in your component
 * add fill='white' as an attribute => Makes the F white
 * THEN
 * ADD a class to your instantiated component apply (background-color: #4267B2)
 * this will match the facebook icon and background color => make background facebook blue
 */
export default {
  name: 'Facebook',
  props: {
    height: {
      type: String,
      default: '22px',
    },
    width: {
      type: String,
      default: '22px',
    },
    fill: {
      type: String,
      default: '#3B5998',
    },
  },

};
